import { Module, MutationTree, ActionTree } from 'vuex'

interface MenuState {
  isOpen: boolean;
}

const state: MenuState = {
  isOpen: false
}

const mutations: MutationTree<MenuState> = {
  TOGGLE_MENU (state) {
    state.isOpen = !state.isOpen
  }
}

const actions: ActionTree<MenuState, any> = {
  toggleMenu ({ commit }) {
    commit('TOGGLE_MENU')
  }
}

const menuModule: Module<MenuState, any> = {
  namespaced: true,
  state,
  mutations,
  actions
}

export default menuModule
